import { MobXProviderContext } from "mobx-react";
import React from "react";
import type { Stores } from "../store/web-stores";

export function useStores() {
  return React.useContext(MobXProviderContext) as Stores;
}
